import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { formatPhoneNumber } from '~/utils/formatter'

import { PhoneNumber } from '@mangovoice/types'

interface OutboundPhoneSearchListItemProps {
  phoneNumber: PhoneNumber
}
export const OutboundPhoneSearchListItem = ({
  phoneNumber,
}: OutboundPhoneSearchListItemProps) => {
  return (
    <Flex paddingX={'.75rem'} paddingY={'.5rem'}>
      <Text
        fontSize={'1rem'}
        fontWeight={'400'}
        color={'fg.default'}
      >{`${phoneNumber.name}: ${formatPhoneNumber(phoneNumber.number)}`}</Text>
    </Flex>
  )
}
